module.exports = __webpack_public_path__ + "img/collection-weddingRingsMen.64ca6d1.jpg";